/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/dashboard/widgets/shop-views/dashboard.widgets.shop-views.component.ts.
 */
import {Component, OnDestroy, OnInit} from '@angular/core';
import {AppViewService} from '../../../../services/app.view.service';
import {Subscription} from 'rxjs';
import {View} from '../../../../models/view';
import {AppAsyncTimeout} from '../../../../helpers/app.asyncTimeout';

/**
 * Zweck: Beschreibt class DashboardWidgetsShopViewsComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    selector: 'app-dashboard-widgets-shop-views',
    templateUrl: 'dashboard.widgets.shop-views.component.html',
    styleUrls: ['dashboard.widgets.shop-views.component.scss'],
    standalone: false
})
export class DashboardWidgetsShopViewsComponent implements OnInit, OnDestroy {
  static id = 'DashboardWidgetsShopViewsComponent';
  static label = 'Shops';
  static description = 'Zeigt die verfügbaren Shop-Ansichten an.';
  static cols = 6;
  static rows = 6;

  vsub: Subscription;

  views: View[] = [];

  reload_done_once = false;

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private svc: AppViewService) {
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    this.vsub = this.svc.menu_views$.subscribe(vs => {
      this.views = vs;
      if (vs && vs.length == 0 || !vs) {
        if (!this.reload_done_once) {
          this.reload_done_once = true;
          this.svc.load();
        } else {
          AppAsyncTimeout.setTimeout(() => {
            this.svc.load();
          }, 1000);
        }
      }
    });
  }

/**
 * Beschreibt Methode ngOnDestroy und ihren Rückgabevertrag.
 */
  ngOnDestroy(): void {
    if (this.vsub instanceof Subscription) {
      this.vsub.unsubscribe();
    }
  }





}
